export default function Wishlist(props) {
  return (
    <div className="Wishlist">
      <center>
        <h1>wishlist feature coming soon</h1>

      </center>
    </div>
  )
}